import UseToggle from "../../Hooks/UseToggle";
import UserProfileMenu from "./UserProfileMenu";
import { RiArrowDownWideLine } from "react-icons/ri";
import PropertyList from "./Properties/PropertyList";
import { FaBell, FaUserCircle } from "react-icons/fa";
import { Navbar, Container, Button, Dropdown, Badge } from "react-bootstrap";
import { MdOutlineMonitorHeart } from "react-icons/md";
import { GoComment, GoSearch } from "react-icons/go";

const Header = ({
  onMenuClick,
  setOpenModule,
  openModule,
  currentUserData,
  getCurrectLoginUser,
  getSinglePlateformSettings,
  plateformSettings,
}) => {
  const toggles = UseToggle();

  return (
    <>
      <Navbar bg="white" className="header border-bottom px-2">
        <Container fluid className="d-flex justify-content-between align-items-center">
          <div className="d-flex align-items-center gap-2">
            <Button className="icon-btn d-md-none profile-btn" onClick={onMenuClick}>
              ☰
            </Button>

            <Navbar.Brand
              className="d-flex align-items-center gap-2 mb-0"
              onClick={() => { if (currentUserData?.propertyCount > 1) toggles.setToggle() }}
              style={{ cursor: "pointer" }}
              title="Change Properties"
            >
              <img
                src={currentUserData?.loginPropertyIcon || "https://tawk.link/5edc81e54a7c6258179a1405/var/logo/u30481uPlW.png?width=40&height=40"}
                alt="logo"
                className="brand-logo"
              />
              <div className="position-relative" style={{ lineHeight: 1.2 }}>
                <p className="m-0 brand-text fw-bold">{currentUserData?.loginPropertyName}</p>
                <p className="m-0 brand-text" style={{ fontSize: 10 }}>{currentUserData?.loginAccountName}</p>
              </div>
              {currentUserData?.propertyCount > 1 &&
                <RiArrowDownWideLine className="brand-text" />
              }
            </Navbar.Brand>
          </div>

          <div className="d-flex align-items-center gap-2">
            <button
              title="Monitoring"
              onClick={(e) => setOpenModule("monitoring")}
              className={`icon-btn position-relative ${openModule === "monitoring" ? "bg-primary-subtle text-primary" : ""}`}
            >
              <MdOutlineMonitorHeart />
              <Badge bg="danger" pill className="notification-badge">
                3
              </Badge>
            </button>
            <button
              title="Active Chats"
              onClick={(e) => setOpenModule("activeChats")}
              className={`icon-btn position-relative ${openModule === "activeChats" ? "bg-primary-subtle text-primary" : ""}`}
            >
              <GoComment />
              <Badge bg="danger" pill className="notification-badge">
                3
              </Badge>
            </button>
            <button className="icon-btn position-relative">
              <FaBell size={18} />
              <Badge bg="danger" pill className="notification-badge">
                3
              </Badge>
            </button>
            <button className="icon-btn">
              <GoSearch />
            </button>
            <Dropdown align="end">
              <Dropdown.Toggle className="profile-btn">
                <FaUserCircle size={22} />
                <span className="d-none d-md-inline ms-1">{currentUserData?.name}</span>
              </Dropdown.Toggle>

              <UserProfileMenu setOpenModule={setOpenModule} currentUserData={currentUserData} getSinglePlateformSettings={getSinglePlateformSettings} plateformSettings={plateformSettings} />
            </Dropdown>
          </div>
        </Container>
      </Navbar>
      <PropertyList
        show={!toggles.toggle}
        getCurrectLoginUser={getCurrectLoginUser}
        currentUserData={currentUserData}
        hide={() => toggles.setToggle()}
        title={`Property List`}
      />
    </>
  );
};

export default Header;
